import { DropDownFilterBy } from '../components/DropDown/types/enums';

/**
 * @description scrollToElementId makes page scroll on Y-axis to provided `id` of element.
 * @param sId element id to be scroll at viewport.
 * @param offset maintain offset from top of the page.
 */
function scrollToElementId(sId: string, offset?: number) {
  const scrollElement = document.querySelector(`#${sId}`);
  if (scrollElement) {
    const targetElementOffsetTop = (scrollElement as HTMLElement).offsetTop;
    const scrollTop = targetElementOffsetTop - (offset ?? 0); // Adjust the offset as needed
    window.scrollTo({
      top: scrollTop,
      behavior: 'smooth',
    });
  }
}

function getContainerPortalId(portalContainerId: string) {
  return typeof window !== 'undefined' ? document.getElementById(portalContainerId) : null;
}

function filterSearchIgnoreCase(mainText: string, searchText: string, filterBy?: string) {
  return filterBy === DropDownFilterBy.STARTS_WITH
    ? mainText?.toLowerCase().startsWith(searchText?.toString().toLowerCase() || '')
    : mainText?.toLowerCase().includes(searchText?.toString().toLowerCase() || '');
}

export { scrollToElementId, getContainerPortalId, filterSearchIgnoreCase };
